import styled, { css } from 'styled-components';
import { Icon } from 'src/components';

export const InputWrapper = styled.div(
  ({ theme }) => css`
    color: ${theme.co.secondary0};
  `,
);

export const SearchIcon = styled(Icon)(
  ({ theme }) => css`
    position: absolute;
    padding: ${theme.sz.s4};
    & svg {
      width: ${theme.sz.s5};
      height: ${theme.sz.s5};
    }
  `,
);

export const Input = styled.input.attrs({ dir: 'auto', type: 'search' })(
  ({ theme }) => css`
    width: 100%;
    ${theme.typography.paragraph.base};
    background: ${theme.co.neutral98};
    border: none;
    border-radius: ${theme.bo.small};
    padding: ${theme.sz.s4};
    padding-left: ${theme.sz.s12};

    &::placeholder {
      color: ${theme.co.secondary60};
      text-align: left;
    }

    &:focus-visible {
      box-shadow: 0 0 0 ${theme.sz.s05} ${theme.co.neutral90};
    }

    @media (max-width: ${theme.sz.md}) {
      border-radius: 0;
    }

    &::-webkit-search-cancel-button {
      cursor: pointer;
    }
  `,
);
